import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Cyber Security Foundations & Digital Defense Basics",
    description:
      "Understanding the evolving cyber threat landscape, Types of attacks: Malware Phishing Ransomware DoS, Importance of cybersecurity in modern systems, Core concepts: CIA Triad Risk Vulnerability Exploit",
  },
  {
    title: "Networking Essentials for Security Professionals",
    description:
      "OSI & TCP/IP model understanding, IP addressing ports protocols, Firewalls proxies & VPN fundamentals, Packet flow & network monitoring basics",
  },
  {
    title: "Operating Systems & System Hardening",
    description:
      "Windows & Linux security structure, User permissions access control & privilege management, System logs auditing & monitoring, Hardening techniques to reduce attack surface",
  },
  {
    title: "Ethical Hacking & Penetration Testing Concepts",
    description:
      "Difference between ethical hacking & cybercrime, Phases of penetration testing (Recon → Exploit → Report), Vulnerability discovery basics, Introduction to tools like Nmap Burp Suite Metasploit",
  },
  {
    title: "Web Application Security & OWASP Top 10",
    description:
      "Understanding web app architecture, Common attacks: SQL Injection XSS CSRF IDOR, Secure coding practices, Real-time testing of web applications",
  },
  {
    title: "Cryptography & Data Protection Techniques",
    description:
      "Encryption basics: symmetric vs asymmetric, Hashing & digital signatures, SSL/TLS & secure communication, Real-world cryptography applications",
  },
  {
    title: "Monitoring, Incident Response & Threat Management",
    description:
      "Detecting suspicious user and system behavior, SIEM tools basics (e.g., Splunk ELK), Steps of incident response, Containment eradication & recovery processes",
  },
  {
    title: "Cloud Security & Identity Management",
    description:
      "Cloud vulnerabilities & shared responsibility model, IAM (Identity & Access Management), MFA SSO & role-based access, Securing cloud workloads & serverless systems",
  },
  {
    title: "Cyber Laws, Compliance & Security Frameworks",
    description:
      "Overview of cybersecurity laws in India & globally, GDPR HIPAA ISO 27001 basics, Importance of compliance in organisations, Risk assessment & policy creation",
  },
  {
    title: "Capstone Security Project & Career Preparation",
    description:
      "Real-world cybersecurity attack simulation, Conducting mini penetration tests, Incident report creation & presentation, Resume building (Cyber roles) GitHub portfolio, Interview prep for Cyber Analyst Ethical Hacker & SOC roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
